import { Flex, Input } from "@chakra-ui/react";
import { ChangeEvent } from "react";
import { FieldComponentProps } from "./types";

const getValueForDateQuestion = (
  event: ChangeEvent<HTMLInputElement>,
): string => {
  const parent = event.target.parentElement;
  if (!parent) {
    return "";
  }

  const day =
    parent.children[0] instanceof HTMLInputElement
      ? parent.children[0].value
      : "0";
  const month =
    parent.children[1] instanceof HTMLInputElement
      ? parent.children[1].value
      : "0";
  const year =
    parent.children[2] instanceof HTMLInputElement
      ? parent.children[2].value
      : "0";

  return `${year}-${month}-${day}`;
};

export function FieldDate(props: FieldComponentProps) {
  return (
    <Flex id={props.id}>
      <Input
        onChange={(event) => {
          props.updateValue({
            label: props.label,
            value: getValueForDateQuestion(event),
          });
        }}
        aria-label="Tag"
        placeholder="TT"
        width="6ch"
        type="text"
        value={props.value.split("-")[2] || ""}
      />
      <Input
        onChange={(event) => {
          props.updateValue({
            label: props.label,
            value: getValueForDateQuestion(event),
          });
        }}
        aria-label="Monat"
        placeholder="MM"
        width="6ch"
        ml={4}
        type="text"
        value={props.value.split("-")[1] || ""}
      />
      <Input
        onChange={(event) => {
          props.updateValue({
            label: props.label,
            value: getValueForDateQuestion(event),
          });
        }}
        aria-label="Jahr"
        placeholder="JJJJ"
        width="12ch"
        ml={4}
        type="text"
        value={props.value.split("-")[0] || ""}
      />
    </Flex>
  );
}
